import "./media-viewer.scss";
import { PageComponent, PageState } from "barba";
import TinySlider from "utils/tiny-slider";

class MediaViewer {
    constructor({ node }) {
        this.node = node;
        this.json = null;
        this.isFirstInit = true;

        try {
            this.json = JSON.parse(this.node.querySelector('script[type="application/json"]').innerHTML);
        } catch (error) {
            console.error("Media Viewer, error in JSON format.");
            setTimeout(() => history.back(), 1000);
            return;
        }

        this.slider = null;
        this.slideCount = this.json.slides ? this.json.slides.length : 0;
        this.sliderOpts = () => ({
            container: this.node.querySelector(".media-viewer__tns"),
            prevButton: this.node.querySelector(".media-viewer__prev"),
            nextButton: this.node.querySelector(".media-viewer__next"),
            nav: false,
            loop: true,
            speed: 500,
            startIndex: PageState.get("startIndex") || 0,
            onInit: () => this.autoplay()
        });

        this.createHtml();

        this.clickHandler = this.click.bind(this);
        this.node.addEventListener("click", this.clickHandler);

        if (this.node.querySelectorAll(".media-viewer__item").length > 1) {
            this.slider = new TinySlider(this.sliderOpts);
            this.slider.events.on("indexChanged", (i) => {
                PageState.set("startIndex", Math.max(0, i.displayIndex - 1));
                // Remove all video iframe
                this.node.querySelectorAll(".media-viewer__iframe").forEach((x) => {
                    x.parentNode.removeChild(x);
                });
            });
        } else {
            this.autoplay();
        }
    }

    createHtml() {
        this.node.innerHTML = `
            <img class="media-viewer__bg-img" src="/dist/assets/footer/mountain.svg" alt="" />
            <div class="media-viewer__ctrl">
                <button class="media-viewer__prev btn-secondary ${this.slideCount <= 1 ? "hidden" : ""}" title="${
            this.json.previousLabel || ""
        }">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.38" height="8.33" viewBox="0 0 13.38 8.33"><path fill="currentcolor" d="M4.24 8.09a.69.69 0 01-1.05 0L.22 4.76a.92.92 0 01-.1-1.05.7.7 0 01.1-.13L3.2.24a.69.69 0 011.05 0 .9.9 0 010 1.18l-1.7 1.91h10.1c.4 0 .73.38.73.84s-.33.83-.74.83H2.53l1.71 1.9c.3.33.3.86 0 1.19z"/></svg>
                </button>
                <button class="media-viewer__next btn-secondary ${this.slideCount <= 1 ? "hidden" : ""}" title="${
            this.json.nextLabel || ""
        }">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.38" height="8.33" viewBox="0 0 13.38 8.33"><path fill="currentcolor" d="M9.13.24a.69.69 0 011.05 0l2.98 3.34a.93.93 0 01.1 1.05.75.75 0 01-.1.13l-2.98 3.33a.69.69 0 01-1.05 0 .9.9 0 010-1.18L10.83 5H.74C.34 5 0 4.63 0 4.17s.33-.84.74-.84h10.1l-1.7-1.9a.9.9 0 010-1.19z"/></svg>
                </button>
                <a class="media-viewer__close btn-primary" href="javascript:history.back()" title="${
                    this.json.closeLabel || ""
                }"></a>
            </div>
            <div class="media-viewer__tns"></div>
        `;

        if (!this.json.slides) return;

        const tns = this.node.querySelector(".media-viewer__tns");
        this.json.slides.forEach((x) => {
            if (!x.type) return;
            switch (x.type) {
                case "image":
                    tns.appendChild(this.createImageSlide(x));
                    break;
                case "youtube":
                    tns.appendChild(this.createYoutubeSlide(x));
                    break;
            }
        });
    }

    createImageSlide(obj) {
        let elm = document.createElement("div");
        elm.classList.add("media-viewer__item");
        elm.setAttribute("data-no-context-menu", "");

        const src = obj.src || null;

        if (!src) return elm;

        elm.innerHTML = `
            <picture class="media-viewer__pic context-menu-disabled">
                <source type="image/webp" srcset="${src}?mode=max&format=webp&width=3840&height=2160" />
                <source type="image/jpeg" srcset="${src}?mode=max&format=jpeg&bgcolor=222121&width=3840&height=2160" />
                <img class="media-viewer__img" src="${src}?mode=max&format=jpeg&bgcolor=222121&width=3840&height=2160" alt="${
            obj.alt || ""
        }" data-loaded-class="opacity-100" />
            </picture>
        `;

        return elm;
    }

    createYoutubeSlide(obj) {
        let elm = document.createElement("div");
        elm.classList.add("media-viewer__item");

        const poster = obj.poster || null;
        const videoId = obj.videoId || null;

        if (!videoId) return elm;

        let picture = "";
        if (poster) {
            picture = `
                <picture class="media-viewer__pic">
                    <source media="(min-width: 1440px)" type="image/webp" srcset="${poster}?mode=crop&format=webp&width=1920&height=1080" />
                    <source media="(min-width: 1200px)" type="image/webp" srcset="${poster}?mode=crop&format=webp&width=1440&height=810" />
                    <source media="(min-width: 992px)" type="image/webp" srcset="${poster}?mode=crop&format=webp&width=1200&height=675" />
                    <source media="(min-width: 768px)" type="image/webp" srcset="${poster}?mode=crop&format=webp&width=992&height=558" />
                    <source media="(min-width: 568px)" type="image/webp" srcset="${poster}?mode=crop&format=webp&width=768&height=432" />
                    <source type="image/webp" srcset="${poster}?mode=crop&format=webp&width=568&height=320" />

                    <source media="(min-width: 1440px)" type="image/jpeg" srcset="${poster}?mode=crop&format=jpeg&bgcolor=222121&width=1920&height=1080" />
                    <source media="(min-width: 1200px)" type="image/jpeg" srcset="${poster}?mode=crop&format=jpeg&bgcolor=222121&width=1440&height=810" />
                    <source media="(min-width: 992px)" type="image/jpeg" srcset="${poster}?mode=crop&format=jpeg&bgcolor=222121&width=1200&height=675" />
                    <source media="(min-width: 768px)" type="image/jpeg" srcset="${poster}?mode=crop&format=jpeg&bgcolor=222121&width=992&height=558" />
                    <source media="(min-width: 568px)" type="image/jpeg" srcset="${poster}?mode=crop&format=jpeg&bgcolor=222121&width=768&height=432" />
                    <source type="image/jpeg" srcset="${poster}?mode=crop&format=jpeg&bgcolor=222121&width=568&height=320" />
                    
                    <img class="media-viewer__img object-cover" src="${poster}?mode=crop&format=jpeg&bgcolor=222121&width=1920&height=1080" alt="" data-loaded-class="opacity-100" />
                </picture>
            `;
        }

        elm.innerHTML = `
            <div class="media-viewer__video relative" data-video-id="${videoId}">
                <div class="media-viewer__poster">
                    ${picture}
                    <div class="media-viewer__play">
                        <button class="btn-primary h-48 px-0 w-64 md:h-64 md:w-80 rounded">
                            <span class="bg-center bg-no-repeat bg-play-secondary-800 bg-contain block h-20 w-20"></span>
                        </button>
                    </div>
                </div>
            </div>
        `;

        return elm;
    }

    click(e) {
        const play = e.target.closest(".media-viewer__play");
        if (!play) return;

        const video = play.closest(".media-viewer__video");
        if (!video) return;

        this.play();
    }

    play() {
        let slide = null;
        if (this.slideCount > 1) {
            slide = this.node.querySelector(".tns-slide-active");
        } else {
            slide = this.node.querySelector(".media-viewer__item");
        }
        if (!slide) return;

        const video = slide.querySelector(".media-viewer__video");
        if (!video) return;

        const videoId = video.dataset.videoId;
        if (!videoId) return;

        let iframe = document.createElement("iframe");
        iframe.classList.add("media-viewer__iframe");
        iframe.width = 560;
        iframe.width = 315;
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        iframe.frameBorder = 0;
        iframe.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
        iframe.allowfullscreen = "";

        video.prepend(iframe);
    }

    autoplay() {
        if (this.isFirstInit) this.play();
        this.isFirstInit = false;
    }

    destroy() {
        this.node.removeEventListener("click", this.clickHandler);

        if (this.slider && this.slider.destroy) {
            this.slider.destroy();
        }

        delete this.node;
        delete this.json;
        delete this.isFirstInit;
        delete this.slider;
        delete this.slideCount;
        delete this.sliderOpts;
        delete this.clickHandler;
    }
}

new PageComponent(".media-viewer", MediaViewer);
